package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GetMerchantProfileResponseModel(
    val email: String? = null,
    val companyName: String? = null,
    val dialCode: String? = null,
    val phoneNumber: String? = null,
    val bulstat: String? = null,
    val iban: String? = null,
    val logoImageUrl: String? = null,
    val countryId: Int? = null,
    val cityId: Long? = null,
    val companyStreet: String? = null
) : BaseResponseModel()
